import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function CallPurposeSection() {
  return (
    <Stack spacing={3} alignItems="flex-start">
      <Text variant="h6" textAlign="center">
        What&apos;s the purpose of this call?
      </Text>
      <Stack spacing={2} alignItems="flex-start" sx={{ paddingLeft: 4 }}>
        <Text variant="h6">• One-time 10 minute phone call with Clipboard</Text>
        <Text variant="h6">• Discuss our attendance policy</Text>
        <Text variant="h6">• Help you book your first Instant Interview!</Text>
      </Stack>
    </Stack>
  );
}
